var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19911_139090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.6C6.5 10.2686 6.23137 10 5.9 10H5.1C4.76863 10 4.5 10.2686 4.5 10.6V16.4C4.5 16.7314 4.76863 17 5.1 17H5.9C6.23137 17 6.5 16.7314 6.5 16.4V10.6ZM12.5 10.6C12.5 10.2686 12.2314 10 11.9 10H11.1C10.7686 10 10.5 10.2686 10.5 10.6V16.4C10.5 16.7314 10.7686 17 11.1 17H11.9C12.2314 17 12.5 16.7314 12.5 16.4V10.6ZM21 19.6C21 19.2686 20.7314 19 20.4 19H2.6C2.26863 19 2 19.2686 2 19.6V20.4C2 20.7314 2.26863 21 2.6 21H20.4C20.7314 21 21 20.7314 21 20.4V19.6ZM18.5 10.6C18.5 10.2686 18.2314 10 17.9 10H17.1C16.7686 10 16.5 10.2686 16.5 10.6V16.4C16.5 16.7314 16.7686 17 17.1 17H17.9C18.2314 17 18.5 16.7314 18.5 16.4V10.6ZM10.8335 6.36951C10.8624 6.37187 10.8915 6.37212 10.9204 6.37027L16.71 6H6.29L10.8335 6.36951ZM11.9164 0.910211C11.7363 0.809301 11.5169 0.808059 11.3357 0.906926L2.31265 5.82943C2.11992 5.93458 2 6.1366 2 6.35615V7.4C2 7.73137 2.26863 8 2.6 8H20.4C20.7314 8 21 7.73137 21 7.4V6.35157C21 6.13446 20.8827 5.93428 20.6933 5.82814L11.9164 0.910211Z",
    fill: "#204887"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 9.75,
    width: 2.025,
    height: 7.5,
    rx: 0.6,
    fill: "#204887"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 9.75,
    width: 2.025,
    height: 7.5,
    rx: 0.6,
    fill: "#204887"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 9.75,
    width: 2.025,
    height: 7.5,
    rx: 0.6,
    fill: "#204887"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19911_139090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.381f3861d471ae541cddc7ffa0137ade.svg";
export { ForwardRef as ReactComponent };